'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var protobuf = require('protons');

var keysPBM = protobuf(require('./keys.proto'));

require('node-forge/lib/asn1');

require('node-forge/lib/pbe');

var forge = require('node-forge/lib/forge');

var errcode = require('err-code');

var importer = require('./importer');

exports = module.exports;
var supportedKeys = {
  rsa: require('./rsa-class'),
  ed25519: require('./ed25519-class'),
  secp256k1: require('./secp256k1-class')(keysPBM, require('../random-bytes'))
};
exports.supportedKeys = supportedKeys;
exports.keysPBM = keysPBM;
var ErrMissingSecp256K1 = {
  message: 'secp256k1 support requires libp2p-crypto-secp256k1 package',
  code: 'ERR_MISSING_PACKAGE'
};

function typeToKey(type) {
  var key = supportedKeys[type.toLowerCase()];

  if (!key) {
    var supported = Object.keys(supportedKeys).join(' / ');
    throw errcode(new Error("invalid or unsupported key type ".concat(type, ". Must be ").concat(supported)), 'ERR_UNSUPPORTED_KEY_TYPE');
  }

  return key;
}

exports.keyStretcher = require('./key-stretcher');
exports.generateEphemeralKeyPair = require('./ephemeral-keys'); // Generates a keypair of the given type and bitsize

exports.generateKeyPair = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, bits) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", typeToKey(type).generateKeyPair(bits));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // Generates a keypair of the given type and bitsize
// seed is a 32 byte uint8array


exports.generateKeyPairFromSeed = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, seed, bits) {
    var key;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // eslint-disable-line require-await
            key = typeToKey(type);

            if (!(type.toLowerCase() !== 'ed25519')) {
              _context2.next = 3;
              break;
            }

            throw errcode(new Error('Seed key derivation is unimplemented for RSA or secp256k1'), 'ERR_UNSUPPORTED_KEY_DERIVATION_TYPE');

          case 3:
            return _context2.abrupt("return", key.generateKeyPairFromSeed(seed, bits));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}(); // Converts a protobuf serialized public key into its
// representative object


exports.unmarshalPublicKey = function (buf) {
  var decoded = keysPBM.PublicKey.decode(buf);
  var data = decoded.Data;

  switch (decoded.Type) {
    case keysPBM.KeyType.RSA:
      return supportedKeys.rsa.unmarshalRsaPublicKey(data);

    case keysPBM.KeyType.Ed25519:
      return supportedKeys.ed25519.unmarshalEd25519PublicKey(data);

    case keysPBM.KeyType.Secp256k1:
      if (supportedKeys.secp256k1) {
        return supportedKeys.secp256k1.unmarshalSecp256k1PublicKey(data);
      } else {
        throw errcode(new Error(ErrMissingSecp256K1.message), ErrMissingSecp256K1.code);
      }

    default:
      typeToKey(decoded.Type);
    // throws because type is not supported
  }
}; // Converts a public key object into a protobuf serialized public key


exports.marshalPublicKey = function (key, type) {
  type = (type || 'rsa').toLowerCase();
  typeToKey(type); // check type

  return key.bytes;
}; // Converts a protobuf serialized private key into its
// representative object


exports.unmarshalPrivateKey = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(buf) {
    var decoded, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // eslint-disable-line require-await
            decoded = keysPBM.PrivateKey.decode(buf);
            data = decoded.Data;
            _context3.t0 = decoded.Type;
            _context3.next = _context3.t0 === keysPBM.KeyType.RSA ? 5 : _context3.t0 === keysPBM.KeyType.Ed25519 ? 6 : _context3.t0 === keysPBM.KeyType.Secp256k1 ? 7 : 12;
            break;

          case 5:
            return _context3.abrupt("return", supportedKeys.rsa.unmarshalRsaPrivateKey(data));

          case 6:
            return _context3.abrupt("return", supportedKeys.ed25519.unmarshalEd25519PrivateKey(data));

          case 7:
            if (!supportedKeys.secp256k1) {
              _context3.next = 11;
              break;
            }

            return _context3.abrupt("return", supportedKeys.secp256k1.unmarshalSecp256k1PrivateKey(data));

          case 11:
            throw errcode(new Error(ErrMissingSecp256K1.message), ErrMissingSecp256K1.code);

          case 12:
            typeToKey(decoded.Type);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x6) {
    return _ref3.apply(this, arguments);
  };
}(); // Converts a private key object into a protobuf serialized private key


exports.marshalPrivateKey = function (key, type) {
  type = (type || 'rsa').toLowerCase();
  typeToKey(type); // check type

  return key.bytes;
};
/**
 *
 * @param {string} encryptedKey
 * @param {string} password
 */


exports.import = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(encryptedKey, password) {
    var _key, key, der;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return importer.import(encryptedKey, password);

          case 3:
            _key = _context4.sent;
            return _context4.abrupt("return", exports.unmarshalPrivateKey(_key));

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);

          case 9:
            // Only rsa supports pem right now
            key = forge.pki.decryptRsaPrivateKey(encryptedKey, password);

            if (!(key === null)) {
              _context4.next = 12;
              break;
            }

            throw errcode(new Error('Cannot read the key, most likely the password is wrong or not a RSA key'), 'ERR_CANNOT_DECRYPT_PEM');

          case 12:
            der = forge.asn1.toDer(forge.pki.privateKeyToAsn1(key));
            der = Buffer.from(der.getBytes(), 'binary');
            return _context4.abrupt("return", supportedKeys.rsa.unmarshalRsaPrivateKey(der));

          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function (_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();